import $ from "jquery";

let timer = null;
let spinnerWait = 1000;
function disableSubmitButton() {
    $("button[data-disable-on-submit]:enabled, input[type='submit'][data-disable-on-submit]:enabled, input[type='button'][data-disable-on-submit]:enabled").each(function() {
        const $enabledButton = $(this);
        const $disabledButton = $(this).clone().prop("disabled", true);
        $disabledButton.insertAfter($enabledButton);
        $enabledButton.hide();
    });
}

function enableSubmitButton() {
    $("button[data-disable-on-submit]:disabled, input[type='submit'][data-disable-on-submit]:disabled, input[type='button'][data-disable-on-submit]:disabled").remove();
    $("button[data-disable-on-submit]:enabled, input[type='submit'][data-disable-on-submit]:enabled, input[type='button'][data-disable-on-submit]:enabled").show();
}

function showSpinner(message, settimer = true) {
    if (message !== undefined) {
        $("#layoutModalSpinnerMessage").html(message);
    }

    //
    // Already a timer going
    //
    if (timer != null) {
        return;
    }

    if (settimer === undefined || settimer) {
        timer = setTimeout(showModal, spinnerWait);
    } else {
        showModal();
    }
}

function showModal() {
    $("#layoutModalSpinner").show();
}

function hideSpinner() {
    if (timer !== null) {
        clearTimeout(timer);
        timer = null;
    }
    $("#layoutModalSpinner").hide();
    $("#layoutModalSpinnerMessage").html("Loading...");
}

function setSpinnerWait(spinnerwait) {
    spinnerWait = spinnerwait;
}

function openPrintWindow(url, print = false) {
    const windowWidth = 800;
    const windowHeight = 600;
    const left = (screen.width - windowWidth) / 2;
    const top = (screen.height - windowHeight) / 4;
    const myWindow = window.open(url, "_blank", "top= " + top + ",left = " + left + ",width= " + windowWidth + ", height= " + windowHeight + ", location=no, toolbars=no, scrollbars=yes");
    myWindow.focus();
    if (print === true) {
        myWindow.print();
    }
    return myWindow;
}

export const forms = {
    disableSubmitButton: disableSubmitButton,
    enableSubmitButton: enableSubmitButton,
    showSpinner: showSpinner,
    hideSpinner: hideSpinner,
    setSpinnerWait: setSpinnerWait,
    openPrintWindow: openPrintWindow
};